import React from 'react';
import { FormattedMessage } from 'react-intl';

export const recognizedTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.recognizedTitle"
        defaultMessage="Recognized"
    />
);

export const recognizedDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.recognizedDescription"
        defaultMessage="This designation is for sellers whose items consistently exemplify the best of 1stdibs."
    />
);

export const vettedTitle = (
    <FormattedMessage id="PdpSharedDealerDistinctions.vettedTitle" defaultMessage="Vetted" />
);

export const vettedDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.vettedDescription"
        defaultMessage="Our team of world-class specialists approve every seller on 1stdibs."
    />
);

export const goldSellerTitle = (
    <FormattedMessage id="PdpSharedDealerDistinctions.goldSellerTitle" defaultMessage="Gold" />
);

export const platinumSellerTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.platinumSellerTitle"
        defaultMessage="Platinum"
    />
);

export const tieredSellerDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.tieredSellerDescription"
        defaultMessage="This distinction is for experienced sellers who continually surpass customer expectations."
    />
);

export const diamondSellerTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.diamondSellerTitle"
        defaultMessage="Diamond"
    />
);

export const associationsTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.associationsTitle"
        defaultMessage="Associations"
    />
);

export const associationsDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.associationsDescription"
        defaultMessage="This seller is a vetted member of professional associations."
    />
);
